import React from 'react'
import { t } from 'ttag'
import { shallowEqual, useSelector } from 'react-redux'
import { getPersonality } from 'ducks/respondent'
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar'

const PersonalityBar = () => {
  const { totalAnswers, totalQuestions } = useSelector(
    getPersonality,
    shallowEqual,
  )

  return (
    <ProgressBar
      timeLabel={t`Unlimited time`}
      totalAnswers={totalAnswers}
      totalQuestions={totalQuestions}
    />
  )
}

export default PersonalityBar
